const Pagamento = () => (
    <h1>A função do dinheiro em análise</h1>
)

export default Pagamento;
